module.exports = __webpack_public_path__ + "fonts/f115ff7.ttf";